<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-row
                align="center"
                justify="end"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <div style="height: 0.5rem;">
                        <v-progress-linear
                                v-show="loading"
                                height="8"
                                indeterminate
                                color="primary"
                        ></v-progress-linear>
                    </div>
                    <v-card-text>
                        <v-container>
                            <v-row class="header-image-container">
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-img
                                            src="./../assets/logo.jpg"
                                            lazy-src="./../assets/logo.jpg"
                                            class="grey lighten-2"
                                            max-width="250"
                                    ></v-img>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <p class="text-justify">
                                        {{ $t("resetPassword.text") }}
                                    </p>

                                    <v-alert v-show="error" type="error"
                                             transition="scale-transition">
                                        {{error}}
                                    </v-alert>

                                    <v-alert v-show="success" type="success"
                                             transition="scale-transition">
                                        {{success}}
                                    </v-alert>

                                    <v-form @keyup.native.enter="submit">
                                        <v-text-field
                                                autofocus
                                                id="password"
                                                :label="$t('common.createPassword') + '*'"
                                                name="password"
                                                v-model="password"


                                                :type="showPassword ? 'text' : 'password'"
                                                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                @click:append="showPassword = !showPassword"

                                                :error-messages="passwordErrors"
                                                @input="$v.password.$touch()"
                                                @blur="$v.password.$touch()"
                                        ></v-text-field>
                                        <password
                                                v-model="password"
                                                :secureLength="8"
                                                :strength-meter-only="true"
                                        ></password>
                                        <v-text-field
                                                id="password_confirm"
                                                :label="$t('common.confirmPassword') + '*'"
                                                name="password_confirm"
                                                v-model="passwordConfirm"

                                                :type="showPasswordConfirm ? 'text' : 'password'"
                                                :append-icon="showPasswordConfirm ? 'visibility' : 'visibility_off'"
                                                @click:append="showPasswordConfirm = !showPasswordConfirm"

                                                :error-messages="passwordConfirmErrors"
                                                @input="$v.passwordConfirm.$touch()"
                                                @blur="$v.passwordConfirm.$touch()"
                                        ></v-text-field>
                                    </v-form>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container>
                            <v-row
                            >
                                <v-col
                                        cols="12"
                                        sm="12"
                                        md="12"
                                >
                                    <v-btn x-large color="success" class="login-button" :disabled="loading"
                                           @click="submit">{{ $t("requestPasswordReset.go") }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {required, minLength} from 'vuelidate/lib/validators'
    import Password from 'vue-password-strength-meter'

    export default {
        name: 'ResetPassword',

        components: { Password },
        validations: {
            password: {
                required,
                minLength: minLength(8)
            },
            passwordConfirm: {
                required,
                minLength: minLength(8)
            },
        },

        data: () => ({
            error: null,
            success: null,
            loading: false,

            showPassword: false,
            showPasswordConfirm: false,

            password: '',
            passwordConfirm: ''
        }),
        computed: {
            passwordErrors() {
                const errors = []

                if(!this.$v.password.$dirty) {
                    return errors
                }

                !this.$v.password.required && errors.push(this.$t('common.errors.fieldRequired'))
                !this.$v.password.minLength && errors.push(this.$t('common.errors.fieldMinLength', {amount: 8}))

                return errors
            },
            passwordConfirmErrors() {
                const errors = []

                if(!this.$v.passwordConfirm.$dirty) {
                    return errors
                }

                !this.$v.passwordConfirm.required && errors.push(this.$t('common.errors.fieldRequired'))
                this.$v.passwordConfirm.$model !== this.$v.password.$model && errors.push(this.$t('common.errors.passwordConfirmError'))
                !this.$v.passwordConfirm.minLength && errors.push(this.$t('common.errors.fieldMinLength', {amount: 8}))

                return errors
            },
        },
        created() {
            const email = this.$route.query.user;

            if(typeof email !== 'undefined') {
                this.email = email;
            }
        },
        methods: {
            submit() {
                this.$v.$touch()
                if(!this.$v.$invalid) {
                    this.loading = true;
                    this.error = null;

                    this.$store.dispatch('resetPassword', {
                        password: this.password,
                        token: this.$route.query.token
                    }).then(() => {
                        this.$router.push({
                            name: 'resetPasswordSuccess'
                        });
                    }).catch((response) => {
                        switch(response.status) {
                            case 404:
                                this.error = this.$t('resetPassword.errors.tokenExpired');
                                break;
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
                }
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .login-button {
        width: 100%;
        text-transform: initial;
    }

    .v-card__text {
        padding-bottom: 0 !important;
    }

    .header-image-container {
        height: 75px;
    }
</style>
